export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.bbf3ba99686b5a933b72da314a993c5c.css";